import * as tslib_1 from "tslib";
import { OrmCatalog } from "@natiwi/core/models/catalog";
import { NatModel } from "@natiwi/core/decorators/matadata.decorator";
let OrmCoupon = class OrmCoupon extends OrmCatalog {
    constructor() {
        super();
    }
};
OrmCoupon = tslib_1.__decorate([
    NatModel({
        plural: 'coupons',
        displayName: 'Купон',
        pluralDisplayName: 'Купоны'
    })
], OrmCoupon);
export { OrmCoupon };
